import clock from '../../../../../../assets/images/icons/clock.svg';
import coins from '../../../../../../assets/images/icons/coins.svg';
import floatToCurrency from '../../../../../../utils/floatToCurrency';
import { Container, PredefinedOption } from './styles';

interface IGeneralSummary {
  resultHeaderWidth: number;
  totalTime: number;
  totalPrice: number;
}

export default function GeneralSummary({ resultHeaderWidth, totalPrice, totalTime }: IGeneralSummary) {
  return (
    <Container resultHeaderWidth={resultHeaderWidth}>
      <PredefinedOption backgroundIndex={4} selected={true}>
        <h6>Resumo Total</h6>
        <div>
          <div>
            <img src={clock} alt="" className='sameAsTheme' />
            <span>{totalTime} min</span>
          </div>
          <div>
            <img src={coins} alt="" className='sameAsTheme' />
            <span>{floatToCurrency(totalPrice)}</span>
          </div>
        </div>
      </PredefinedOption>
    </Container>
  );
}
